import styled from '@emotion/styled';
import { Body, Card, H3, LinkButton } from 'imdui';
import ReleasePageIcon from './Mock.svg';
import { useTranslation } from 'react-i18next';

const PromoTemplate = () => (
  <svg
    width="300"
    height="180"
    viewBox="0 0 300 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_455_5740)">
      <rect
        x="2"
        y="1"
        width="296"
        height="176"
        rx="12"
        fill="var(--surface-container-low)"
      />
      <circle cx="46" cy="37" r="20" fill="url(#pattern0)" />
      <rect
        x="90"
        y="17"
        width="32"
        height="8"
        rx="4"
        fill="var(--on-surface)"
        fillOpacity="0.9"
      />
      <rect
        x="90"
        y="41"
        width="120"
        height="56"
        rx="8"
        fill="var(--surface-container-high)"
      />
      <rect
        x="100"
        y="51"
        width="36"
        height="36"
        rx="2"
        fill="var(--surface-container-high)"
      />
      <rect
        x="100"
        y="51"
        width="36"
        height="36"
        rx="2"
        fill="url(#pattern1)"
      />
      <path
        d="M169 66.005V59.9952C169 59.1171 169 58.678 169.185 58.4179C169.346 58.1908 169.595 58.0414 169.871 58.0054C170.187 57.9642 170.575 58.1702 171.351 58.5822L177.007 61.5871C177.87 62.0457 178.302 62.2749 178.443 62.5805C178.566 62.8467 178.566 63.1535 178.443 63.4197C178.302 63.7253 177.87 63.9546 177.007 64.4131L171.351 67.418C170.575 67.83 170.187 68.036 169.871 67.9948C169.595 67.9589 169.346 67.8094 169.185 67.5824C169 67.3223 169 66.8832 169 66.005Z"
        fill="var(--on-surface)"
        fillOpacity="0.9"
      />
      <g clipPath="url(#clip0_455_5740)">
        <rect
          x="146"
          y="81"
          width="54"
          height="2"
          rx="1"
          fill="var(--on-surface)"
          fillOpacity="0.1"
        />
        <rect
          x="146"
          y="81"
          width="21"
          height="4"
          fill="var(--on-surface)"
          fillOpacity="0.9"
        />
      </g>
      <rect
        x="218"
        y="41"
        width="56"
        height="56"
        rx="8"
        fill="var(--surface-container-high)"
      />
      <rect
        x="218"
        y="41"
        width="56"
        height="56"
        rx="8"
        fill="url(#pattern2)"
      />
      <rect
        x="90"
        y="105"
        width="56"
        height="56"
        rx="8"
        fill="var(--surface-container-high)"
      />
      <path
        d="M123.832 129.987C123.841 130.118 123.841 130.248 123.841 130.379C123.841 134.383 120.814 139 115.279 139V138.998C113.644 139 112.043 138.528 110.667 137.639C110.904 137.668 111.143 137.682 111.383 137.683C112.738 137.684 114.054 137.227 115.12 136.384C113.832 136.359 112.703 135.514 112.309 134.279C112.76 134.367 113.224 134.349 113.667 134.227C112.263 133.942 111.253 132.7 111.253 131.257V131.219C111.672 131.454 112.14 131.584 112.619 131.598C111.297 130.709 110.889 128.937 111.688 127.553C113.216 129.446 115.47 130.596 117.889 130.718C117.647 129.666 117.978 128.563 118.76 127.823C119.972 126.676 121.878 126.735 123.017 127.955C123.691 127.821 124.337 127.572 124.928 127.219C124.703 127.92 124.233 128.516 123.605 128.895C124.202 128.824 124.784 128.663 125.333 128.418C124.929 129.027 124.42 129.558 123.832 129.987Z"
        fill="var(--on-surface)"
        fillOpacity="0.9"
      />
      <rect
        x="154"
        y="105"
        width="56"
        height="56"
        rx="8"
        fill="var(--surface-container-high)"
      />
      <g clipPath="url(#clip1_455_5740)">
        <path
          d="M178.963 125.718C178.182 125.755 177.65 125.879 177.184 126.062C176.702 126.25 176.293 126.502 175.887 126.91C175.48 127.318 175.23 127.727 175.043 128.21C174.862 128.677 174.74 129.21 174.706 129.991C174.671 130.772 174.664 131.023 174.667 133.014C174.671 135.006 174.68 135.255 174.718 136.038C174.755 136.818 174.879 137.35 175.062 137.816C175.25 138.298 175.502 138.707 175.91 139.114C176.319 139.52 176.727 139.77 177.211 139.957C177.678 140.137 178.211 140.26 178.992 140.294C179.772 140.328 180.023 140.336 182.014 140.333C184.005 140.329 184.256 140.32 185.038 140.283C185.82 140.246 186.35 140.121 186.816 139.939C187.298 139.75 187.707 139.499 188.113 139.09C188.52 138.682 188.77 138.273 188.957 137.79C189.137 137.323 189.26 136.79 189.294 136.01C189.328 135.227 189.336 134.977 189.332 132.986C189.328 130.995 189.32 130.745 189.282 129.963C189.245 129.181 189.121 128.65 188.938 128.184C188.75 127.702 188.498 127.294 188.09 126.887C187.682 126.48 187.273 126.229 186.79 126.043C186.323 125.863 185.79 125.74 185.009 125.706C184.229 125.672 183.977 125.664 181.986 125.668C179.994 125.671 179.745 125.68 178.963 125.718ZM179.048 138.975C178.333 138.944 177.945 138.825 177.686 138.726C177.344 138.594 177.1 138.434 176.842 138.179C176.584 137.923 176.426 137.678 176.292 137.337C176.191 137.078 176.07 136.69 176.037 135.975C176.001 135.202 175.993 134.97 175.989 133.012C175.984 131.055 175.992 130.823 176.026 130.05C176.056 129.335 176.176 128.947 176.275 128.688C176.407 128.345 176.566 128.101 176.822 127.844C177.078 127.586 177.322 127.427 177.664 127.294C177.923 127.193 178.311 127.073 179.025 127.039C179.799 127.002 180.03 126.995 181.988 126.99C183.946 126.986 184.178 126.993 184.952 127.027C185.666 127.059 186.055 127.177 186.313 127.277C186.656 127.409 186.9 127.567 187.158 127.824C187.415 128.08 187.574 128.323 187.708 128.666C187.809 128.924 187.929 129.312 187.963 130.027C187.999 130.8 188.008 131.032 188.011 132.99C188.015 134.947 188.008 135.179 187.974 135.952C187.943 136.667 187.824 137.056 187.725 137.315C187.593 137.657 187.434 137.901 187.177 138.159C186.921 138.416 186.677 138.575 186.335 138.709C186.077 138.81 185.689 138.93 184.975 138.964C184.201 139 183.97 139.008 182.011 139.012C180.053 139.016 179.822 139.008 179.048 138.975ZM185.027 129.081C185.027 129.255 185.079 129.425 185.176 129.569C185.273 129.714 185.41 129.826 185.571 129.893C185.732 129.959 185.909 129.976 186.08 129.942C186.251 129.908 186.407 129.824 186.53 129.7C186.653 129.577 186.737 129.42 186.77 129.249C186.804 129.078 186.786 128.902 186.719 128.741C186.652 128.58 186.539 128.443 186.394 128.347C186.249 128.25 186.079 128.199 185.905 128.199C185.672 128.2 185.448 128.293 185.283 128.458C185.119 128.623 185.026 128.847 185.027 129.081ZM178.235 133.007C178.239 135.087 179.928 136.769 182.007 136.765C184.086 136.761 185.77 135.072 185.766 132.993C185.762 130.913 184.072 129.23 181.993 129.235C179.913 129.239 178.231 130.928 178.235 133.007ZM179.555 133.005C179.554 132.521 179.697 132.048 179.965 131.646C180.233 131.243 180.614 130.929 181.06 130.743C181.506 130.557 181.998 130.508 182.472 130.601C182.946 130.695 183.382 130.927 183.725 131.268C184.068 131.609 184.301 132.044 184.397 132.518C184.492 132.992 184.444 133.484 184.26 133.931C184.076 134.378 183.764 134.76 183.362 135.03C182.961 135.299 182.488 135.443 182.005 135.444C181.684 135.445 181.366 135.383 181.069 135.26C180.772 135.138 180.502 134.958 180.275 134.732C180.047 134.505 179.867 134.236 179.743 133.94C179.62 133.644 179.556 133.326 179.555 133.005Z"
          fill="var(--on-surface)"
          fillOpacity="0.9"
        />
      </g>
      <rect
        x="2.5"
        y="1.5"
        width="295"
        height="175"
        rx="11.5"
        stroke="var(--on-surface)"
        strokeOpacity="0.1"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_455_5740"
        x="0"
        y="0"
        width="300"
        height="180"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_455_5740"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_455_5740"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_455_5740"
          result="shape"
        />
      </filter>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_455_5740"
          transform="translate(-0.25) scale(0.003125)"
        />
      </pattern>
      <pattern
        id="pattern1"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image1_455_5740"
          transform="translate(-0.25) scale(0.003125)"
        />
      </pattern>
      <pattern
        id="pattern2"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image2_455_5740"
          transform="translate(-0.34507) scale(0.00352113)"
        />
      </pattern>
      <clipPath id="clip0_455_5740">
        <rect x="146" y="81" width="54" height="2" rx="1" fill="white" />
      </clipPath>
      <clipPath id="clip1_455_5740">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(174 125)"
        />
      </clipPath>
      <image
        id="image0_455_5740"
        width="480"
        height="320"
        xlinkHref="/images/artist-page/avatar.png"
      />
      <image
        id="image1_455_5740"
        width="480"
        height="320"
        xlinkHref="/images/artist-page/pic1.png"
      />
      <image
        id="image2_455_5740"
        width="480"
        height="284"
        xlinkHref="/images/artist-page/pic2.png"
      />
    </defs>
  </svg>
);

const PromoCard = styled(Card)`
  padding: 32px;
  width: 100%;
  gap: 32px;
  align-items: center;
  justify-content: center;
  display: flex;
  ${H3} {
    font-weight: 700;
    margin-bottom: 12px;
    max-width: 400px;
  }
  ${Body} {
    display: block;
    max-width: 400px;
  }
`;

export const ArtistPagePromoCard = ({ linkTo }: { linkTo?: string }) => {
  const { t } = useTranslation();
  return (
    <PromoCard>
      <PromoTemplate></PromoTemplate>
      <div>
        <H3>
          {t('promote-as-an-artist', {
            defaultValue: 'Promote yourself as an artist',
          })}
        </H3>
        <Body secondary>
          {t('promote-as-an-artist-text', {
            defaultValue:
              'Create Artist Page to showcase your tracks, publish updates and let your audience subscribe to your updates',
          })}
        </Body>
        {linkTo && (
          <LinkButton
            style={{ marginTop: '16px' }}
            text={t('create-artist-page')}
            to={linkTo}
            size="small"
            position="center"
          />
        )}
      </div>
    </PromoCard>
  );
};

export const ReleasePagePromoCard = ({ linkTo }: { linkTo?: string }) => {
  const { t } = useTranslation();
  return (
    <>
      <PromoCard>
        <ReleasePageIcon />

        <div>
          <H3>
            {t('promote-release', {
              defaultValue: 'Promote release',
            })}
          </H3>
          <Body secondary>
            {t('promote-release-text', {
              defaultValue:
                'Create Release Page to showcase your tracks, publish updates and let your audience subscribe to your updates',
            })}
          </Body>
          {linkTo && (
            <LinkButton
              style={{ marginTop: '16px' }}
              text={t('create-release-page')}
              to={linkTo}
              size="small"
              position="center"
            />
          )}
        </div>
      </PromoCard>
    </>
  );
};
